import React, { Component } from 'react'
import moment from 'moment'
import $ from 'jquery'
import { AppSettings, MessageText, Storage } from '../../configs'

import {
    SecureGateRoute,
    BreadCrumb,
    UserModal,
    DepartmentMapModal,
    DepartmentManageModal
} from "../../components"

import { connect } from 'react-redux'
import { Div, Input, DatePicker, Select, TextArea } from "../../components/core";
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TablePagination from "@material-ui/core/TablePagination";
import TableSortLabel from "@material-ui/core/TableSortLabel";
import { msg } from '../../components/Notifications/MsgBox';

import '../../assets/css/rrs.css'
import { getAllOrgUnitsAction } from '../../redux/actions/MasterAction'
import {
    getAllDepartmentMapAction,
    updatedepartmentMapModalAction,
    deleteDepartmentMapAction,
    getAllUnitReviewerAction,
    updateUnitReviewerModalAction,
    deleteUnitReviewerAction

} from '../../redux/actions/DepartmentMapAction'
import UserServices from '../../services/UserServices';


class DepartmentManageScreen extends Component {
    constructor(props) {
        super(props)

        this.state = {
            order_user: "asc",
            orderBy_user: "",
            page_user: 0,
            rowsPerPage_user: 10,
            filter_unit_Code: '',
            filter_unit_Description: '',
            filter_business_Place_Default: '',
            filter_email_Response: '',
            filterDepartManageArr: [],
            appReadonly: true
        }

        this.handleRequestSort = this.handleRequestSort.bind(this)
        this.handleChangePage = this.handleChangePage.bind(this)
        this.handleChangeRowsPerPage = this.handleChangeRowsPerPage.bind(this)
        this.deleteDepartMap = this.deleteDepartMap.bind(this)
        this.setDefaultPage = this.setDefaultPage.bind(this)
        this.handleChangefilter = this.handleChangefilter.bind(this)
        this.loadDataDapartmentAll = this.loadDataDapartmentAll.bind(this)
        window.onSavePopupDepartmentManage = this.loadDataDapartmentAll.bind(this)

    }

    componentDidMount() {
        this.loadDataDapartmentAll()

        this.handleApplicationCheckReadonly()

        $(function () {
            window.onComponentDidMount()
        })
    }

    async handleApplicationCheckReadonly()
    {
        UserServices.ApplicationReadonly().then(response=>{
            if(response.data === false)
            {
                this.setState({appReadonly: false})
            }
        })
    }

    async loadDataDapartmentAll() {
        const employeePIS = Storage.getEmployeePIS()
        console.log("employeePIS")
        console.log(employeePIS)

        await this.props.getAllOrgUnits()
        await this.props.getAllDepartmentMap()

        if (employeePIS) {
            await this.props.getAllUnitReviewer(employeePIS.departmentCode)
        }

        this.setDefaultPage()
    }

    setDefaultPage() {
        this.setState({
            page_user: 0
        })
    }
    setDepartmentManageModal(index = "") {

        let data = { index: index }
        //this.props.updatedepartmentMapModal(data)
        this.props.updateUnitReviewerModalAction(data)
    }

    deleteDepartMap(unit_id) {
        const { unitreviewerAll } = this.props
        let objdepartment = unitreviewerAll.find(f => f.unit_Id == unit_id)

        if (objdepartment) {
            msg.showConfirm("Confirm",
                MessageText.PAGE.DEPARTMENTMANAGE.POPUP_MSG_CONFIRM_DELETE,
                async () => {
                    msg.hideConfirm()
                    await this.props.deleteUnitReviewer(objdepartment)
                    if (this.props.unitReviewerIsSuccess) {
                        msg.success(MessageText.PAGE.DEPARTMENTMANAGE.POPUP_MSG_SUCCESS_DELETE)
                        this.loadDataDapartmentAll()

                    } else {
                        msg.error(this.props.departmanageErrorMsg)
                    }
                },
                () => {
                    msg.hideConfirm()
                    console.log("On Cancel")
                },
                () => {
                    console.log("On Closed")
                }
            )
        }

    }

    // Grid start

    desc(a, b, orderBy) {
        if (b[orderBy] < a[orderBy]) {
            return -1;
        }
        if (b[orderBy] > a[orderBy]) {
            return 1;
        }
        return 0;
    }

    stableSort(array, cmp) {
        const stabilizedThis = array.map((el, index) => [el, index]);
        stabilizedThis.sort((a, b) => {
            const order = cmp(a[0], b[0]);
            if (order !== 0) return order;
            return a[1] - b[1];
        });
        return stabilizedThis.map(el => el[0]);
    }

    getSorting(order, orderBy) {
        return order === "desc"
            ? (a, b) => this.desc(a, b, orderBy)
            : (a, b) => -this.desc(a, b, orderBy);
    }

    handleRequestSort(event, property) {
        const isDesc = this.state.orderBy_user === property && this.state.order_user === "desc";
        this.setState({
            order_user: isDesc ? "asc" : "desc",
            orderBy_user: property
        })
    }

    handleChangePage(event, newPage) {
        this.setState({
            page_user: newPage
        })
    }

    handleChangeRowsPerPage(event) {
        this.setState({
            rowsPerPage_user: +event.target.value,
            page_user: 0
        })
    }

    // Grid end
    componentWillReceiveProps(nextProps) {
        if (nextProps.unitreviewerAll !== this.state.filterDepartManageArr) {
            this.setState({
                filterDepartManageArr: nextProps.unitreviewerAll
            })
        }
    }

    async handleChangefilter(event) {
        event.preventDefault()
        const { name, value } = event.target;

        await this.setState({ [name]: value })

        let filterDepartManage = []
        filterDepartManage = this.props.unitreviewerAll

        if (this.state.filter_unit_Code) {
            filterDepartManage = filterDepartManage.filter((data) => {
                return data.unit_Code && data.unit_Code.indexOf(this.state.filter_unit_Code) > -1
            })
        }
        if (this.state.filter_unit_Description) {
            filterDepartManage = filterDepartManage.filter((data) => {
                return data.unit_Description && data.unit_Description.indexOf(this.state.filter_unit_Description) > -1
            })
        }
        if (this.state.filter_business_Place_Default) {
            filterDepartManage = filterDepartManage.filter((data) => {
                return data.business_Place_Default && data.business_Place_Default.indexOf(this.state.filter_business_Place_Default) > -1
            })
        }
        if (this.state.filter_email_Response) {
            filterDepartManage = filterDepartManage.filter((data) => {
                return data.email_Response && data.email_Response.indexOf(this.state.filter_email_Response) > -1
            })
        }

        await this.setState({ filterDepartManageArr: filterDepartManage })
        this.setDefaultPage()
    }

    render() {
        const { unitreviewerAll } = this.props
        const { filterDepartManageArr, appReadonly } = this.state
        const roleAdmin = Storage.getRoleAdmin()
        console.log("unitreviewerAll")
        console.log(unitreviewerAll)

        return (
            <div className="rrs">
                <SecureGateRoute />
                <div id="main-content">
                    <div className="page-body">
                        <BreadCrumb breadcrumb={[
                            { name: 'RRS Home', url: AppSettings.defaultUrl },
                            { name: 'Department Management', url: '' }
                        ]}></BreadCrumb>
                        <div className="sp-page-header-panel row">
                            <div className="col-md-5 sp-page-header">
                                <h1 className="sp-page-header1">Department Management </h1>
                            </div>
                        </div>
                        <div className="sp-page-result-container" style={{ marginTop: 18 }} id="user" >
                            <div className="sp-table-container">
                                <div className="row rrs-table-hdr-wrap">
                                    {/* <div className="col-md-2">
                                        <h2 className="rrs-table-hdr">หน่วยงานจัดหา</h2>
                                    </div> */}
                                </div>
                                {roleAdmin && !appReadonly && (
                                    <div className="row sp-pagination-control-top">
                                        <div className="col-auto create-button" >
                                            <a href="#" className="sp-bt-addmore" onClick={() => this.setDepartmentManageModal()} data-toggle="modal" data-target="#departmentManage">
                                                <i className="icon btn-plus" />
                                                <span>เพิ่ม</span>
                                            </a>
                                        </div>
                                    </div>
                                )}
                                <div className="row no-gutters sp-table-content">
                                    <Table aria-labelledby="tableTitle" className="sp-table table rrs-table">
                                        <TableHead>
                                            <TableRow className="sp-table-header">
                                                <TableCell className="th-table text-center" style={{ width: '100px', maxWidth: '100px' }}>รหัสหน่วยงานจัดหา</TableCell>
                                                <TableCell className="th-table text-center" style={{ width: '150px', maxWidth: '150px' }}>ชื่อย่อหน่วยงานจัดหา</TableCell>
                                                <TableCell className="th-table text-center" style={{ width: '100px', maxWidth: '100px' }}>Bus.place/sectn</TableCell>
                                                <TableCell className="th-table text-center" style={{ width: '200px', maxWidth: '200px' }}>E-mail</TableCell>
                                                <TableCell className="th-table text-center" style={{ width: '130px', maxWidth: '130px' }}>Purch.Group</TableCell>
                                                { !appReadonly && <TableCell className="th-table text-center" style={{ width: '80px', maxWidth: '80px' }}>รายละเอียด</TableCell>}
                                                {/* <TableCell className="th-table text-center" style={{ width: '40px', maxWidth: '40px', display: roleAdmin ? "" : "none" }} >Delete</TableCell> */}

                                            </TableRow>
                                            {/* <TableRow className="sp-table-filter">
                                                <TableCell><input type="text" name="filter_unit_Code" className="form-control" onChange={this.handleChangefilter} value={filter_unit_Code} /></TableCell>
                                                <TableCell><input type="text" name="filter_unit_Description" className="form-control" onChange={this.handleChangefilter} value={filter_unit_Description} /></TableCell>
                                                <TableCell><input type="text" name="filter_business_Place_Default" className="form-control" onChange={this.handleChangefilter} value={filter_business_Place_Default} /></TableCell>
                                                <TableCell><input type="text" name="filter_email_Response" className="form-control" onChange={this.handleChangefilter} value={filter_email_Response} /></TableCell>
                                                <TableCell></TableCell>
                                                <TableCell></TableCell> 
                                                <TableCell></TableCell> 
                                            </TableRow> */}
                                        </TableHead>
                                        <TableBody>
                                            {Array.isArray(filterDepartManageArr) && (this.stableSort(filterDepartManageArr, this.getSorting(this.state.order_user, this.state.orderBy_user))
                                                .slice(this.state.page_user * this.state.rowsPerPage_user, this.state.page_user * this.state.rowsPerPage_user + this.state.rowsPerPage_user)
                                                .map((row, index) => {

                                                    let index_start = unitreviewerAll.findIndex(f => f.unit_Id == row.unit_Id)

                                                    return (
                                                        <TableRow
                                                            hover
                                                            tabIndex={-1}
                                                            key={index}
                                                        >
                                                            <TableCell><label className="label-full text-grid">{row.unit_Code}</label></TableCell>
                                                            <TableCell><label className="label-full text-grid">{row.unit_Description}</label></TableCell>
                                                            <TableCell className="text-center"><label className="label-full text-grid">{row.business_Place_Default}</label></TableCell>
                                                            <TableCell><label className=" text-grid">{row.email_Response}</label></TableCell>
                                                            <TableCell className="text-center"><label className="label-full text-grid">{row.s_pgrp + ' - ' + row.e_pgrp}</label></TableCell>
                                                            { !appReadonly && <TableCell className="action-icon">
                                                                <a href="#" onClick={() => this.setDepartmentManageModal(index_start)} data-toggle="modal" data-target="#departmentManage">
                                                                    <i className="icon bt-edit" />
                                                                </a>
                                                            </TableCell>}
                                                            {/*                                                             <TableCell className="action-icon" style={{ display: roleAdmin ? "" : "none" }}>
                                                                <button className="btn" onClick={() => { this.deleteDepartMap(row.unit_Id) }}>
                                                                    <i className="icon btn-trash" />
                                                                </button>
                                                            </TableCell>
 */}                                                        </TableRow>
                                                    );

                                                }))}
                                        </TableBody>
                                    </Table>
                                    <TablePagination
                                        className="pager"
                                        rowsPerPageOptions={[10, 25, 50, 100]}
                                        component="div"
                                        count={this.state.filterDepartManageArr.length}
                                        rowsPerPage={this.state.rowsPerPage_user}
                                        page={this.state.page_user}
                                        backIconButtonProps={{
                                            "aria-label": "previous page"
                                        }}
                                        nextIconButtonProps={{
                                            "aria-label": "next page"
                                        }}
                                        onChangePage={this.handleChangePage}
                                        onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <DepartmentManageModal />

                {/* backtotop button */}
                <div className="backtotop-panel">
                    <span className="bt-backtotop btn">
                        <i className="icon btn-order-top" onClick={() => window.scroll({ top: 0, behavior: 'smooth' })} />
                    </span>
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => {
    const { MasterRedux, DepartmentMapRedux } = state
    return {
        org_unit: MasterRedux.org_unit,
        departmapAll: DepartmentMapRedux.departmapAll,
        isSuccess: DepartmentMapRedux.isSuccess,
        unitreviewerAll: DepartmentMapRedux.unitreviewerAll,
        departmanageErrorMsg: DepartmentMapRedux.departmanageErrorMsg,
        unitReviewerIsSuccess: DepartmentMapRedux.unitReviewerIsSuccess,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        getAllOrgUnits: () => dispatch(getAllOrgUnitsAction()),
        getAllDepartmentMap: () => dispatch(getAllDepartmentMapAction()),
        updatedepartmentMapModal: (data) => dispatch(updatedepartmentMapModalAction(data)),
        deleteDepartmentMap: (data) => dispatch(deleteDepartmentMapAction(data)),
        getAllUnitReviewer: (data) => dispatch(getAllUnitReviewerAction(data)),
        updateUnitReviewerModalAction: (data) => dispatch(updateUnitReviewerModalAction(data)),
        deleteUnitReviewer: (data) => dispatch(deleteUnitReviewerAction(data)),
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(DepartmentManageScreen);